module.exports = __webpack_public_path__ + "img/DSC_1942.fc006459.JPG";